// https://stackoverflow.com/questions/45408920/plain-javascript-scrollintoview-inside-div/45409133#45409133
export default function (parent, child) {
  const parentRect = parent.getBoundingClientRect();
  const parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth,
  };
  const childRect = child.getBoundingClientRect();
  const isViewable = (childRect.top >= parentRect.top) && (childRect.top <= parentRect.top + parentViewableArea.height);

  if (!isViewable) {
    parent.scrollTop = (childRect.top + parent.scrollTop) - parentRect.top; // eslint-disable-line no-param-reassign
  }
}
